import intlTelInput from 'intl-tel-input';

class IntlTelephoneInput {
  constructor() {
    // this.telInputMap = new Map();
    this.init();
  }

  init = () => {
    const getTelInputs = document.querySelectorAll(".intl-tel-input");
    if (!getTelInputs.length) return;

    getTelInputs.forEach(getTelInput => {
      const iti = intlTelInput(getTelInput, {
        loadUtils: () => import("intl-tel-input/utils"),
        strictMode: true,
        nationalMode: true,
        initialCountry: "auto",
        geoIpLookup: callback => {
          fetch("https://api.country.is/")
            .then(res => res.json())
            .then(data => callback(data.country))
            .catch(() => callback("us"));
        },
        formatOnDisplay: true,
        autoPlaceholder: "polite",
      });

      // Dodaj skriveno polje za region
      let regionInput = document.createElement("input");
      regionInput.type = "hidden";
      regionInput.name = "phone-region";
      getTelInput.closest("form").appendChild(regionInput);

      // Ažuriraj region kad se promeni
      getTelInput.addEventListener("countrychange", () => {
        regionInput.value = iti.getSelectedCountryData().iso2.toUpperCase();
      });

      // this.telInputMap.set(getTelInput, iti);

      // Dodajemo listener za input event da bi očistili error stanje
      // getTelInput.addEventListener('input', () => {
      //   getTelInput.classList.remove('wpcf7-not-valid');
      //   getTelInput.setAttribute('aria-invalid', 'false');
      //   const errorElement = getTelInput.closest('form').querySelector('.phone-error');
      //   if (errorElement) {
      //     errorElement.textContent = '';
      //     errorElement.classList.remove('mt-n2');
      //   }
      // });
    });

    // CF7 Event Handlers
    // document.addEventListener('wpcf7invalid', this.handleCF7Invalid);
    // document.addEventListener('wpcf7submit', this.handleCF7Submit);
  }

  // validatePhoneNumber = (phoneInput) => {
  //   const iti = this.telInputMap.get(phoneInput);
  //   if (!iti) return true;

  //   const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
  //   const form = phoneInput.closest('form');
  //   const errorElement = form.querySelector('.phone-error');

  //   if (!iti.isValidNumberPrecise()) {
  //     phoneInput.classList.add('wpcf7-not-valid');
  //     phoneInput.setAttribute('aria-invalid', 'true');

  //     if (errorElement) {
  //       const errorCode = iti.getValidationError();
  //       const msg = errorMap[errorCode] || "Invalid phone number";
  //       errorElement.textContent = msg;
  //       errorElement.classList.add('mt-n2');
  //     }
  //     return false;
  //   }

  //   // Ako je broj validan, spremi E.164 format
  //   const e164Number = iti.getNumber();
  //   const hiddenPhoneField = form.querySelector('input[name="phone-e164"]');
  //   if (hiddenPhoneField) {
  //     hiddenPhoneField.value = e164Number;
  //   }
  //   return true;
  // }

  // handleCF7Submit = (event) => {
  //   const form = event.target;
  //   const phoneInput = form.querySelector(".intl-tel-input");
  //   if (!phoneInput) return;

  //   if (!this.validatePhoneNumber(phoneInput)) {
  //     // Spriječi slanje forme ako broj nije validan
  //     event.preventDefault();
  //     form.classList.add('wpcf7-form-invalid');
  //   }
  // }

  // handleCF7Invalid = (event) => {
  //   const form = event.target;
  //   const phoneInput = form.querySelector(".intl-tel-input");
  //   if (!phoneInput) return;

  //   // Ponovno validiraj telefon kada CF7 kaže da forma nije validna
  //   this.validatePhoneNumber(phoneInput);
  // }
}

export default IntlTelephoneInput;